<template>
  <div class="query-box">
    <div class="query-btn-box">
      <nav class="cancel-btn" @click="handleClose">取 消</nav>
      <nav class="query-btn" @click="onSaveApplicat">保 存</nav>
    </div>    
  </div>
</template>
<script>
export default {
  props: ['applicant'],
  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    // 暂存申请人信息
    onHoldApplicat() {
      this.$emit('onHoldApplicat')
    },
    // 保存申请人信息
    onSaveApplicat() {
      this.$emit('onSaveApplicat');
    },
    // 关闭弹窗
    handleClose() {
      this.$emit('handleClose');
    },
  },
};
</script>
<style lang="less" scoped>
  @import "./index.less";
</style>